import type { EmployerApplication } from "./api";

export type ApplicantFilter = "all" | "applied" | "shortlisted" | "accepted" | "rejected" | "offers";

/** Desktop and mobile Hiring use the same buckets: pending offers leave their
 * application's status bucket until resolved, while All retains every applicant. */
export function matchesApplicantFilter(application: EmployerApplication, filter: ApplicantFilter): boolean {
  if (filter === "all") return true;
  const pendingOffer = application.jobOffer?.status === "sent";
  return filter === "offers" ? pendingOffer : !pendingOffer && application.status === filter;
}
